import React from "react";
import { useTranslation } from "react-i18next";
import Styles from "./WhoWeAre.module.css";
import image1 from "../../assets/Images/2.png";

function WhoWeAre() {
	const { t, i18n } = useTranslation();

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	return (
		<div
			className={
				isRtl ? Styles.ContainerRTL : Styles.Container
			}
		>
			<img
				className={Styles.image}
				src={image1}
				alt='Who we are'
			/>
			<div dir={isRtl ? "rtl" : "ltr"}>
				<h1>{t("AboutUs.title")}</h1>
				<p className={Styles.p}>{t("AboutUs.content")}</p>
			</div>
		</div>
	);
}

export default WhoWeAre;
